// Currency helper - supports INR and SAR
// Currency comes from API config or constants
import { CURRENCY } from "../config/constants";

export const getCurrencySymbol = (currency) => {
  switch (currency?.toUpperCase()) {
    case "SAR":
      return "﷼";
    case "INR":
      return "₹";
    default:
      return "₹";
  }
};

export const formatPrice = (amount, currency) => {
  const c = currency || CURRENCY;
  const sym = getCurrencySymbol(c);
  const decimals = c?.toUpperCase() === "SAR" ? 2 : 0;
  return `${sym}${Number(amount).toFixed(decimals)}`;
};
